<template>
    <form id="frm_action">
      <div class="p-formgrid">
        <div class="description-box text-box">
            <div class="description-items row mt-3" v-for="(item, index) in descriptions" :key="index">
                <div class="col-lg-10">
                    <inputText v-model="item.description" maxlength="255"/>
                </div>
                <div class="col-lg-2 description-gr-icon">
                    <Button icon="pi pi-arrow-up" class="p-button-secondary p-button-link" :disabled="index == 0" @click="moveUp(index)"/>
                    <Button icon="pi pi-arrow-down" class="p-button-secondary p-button-link" :disabled="index == (descriptions.length-1)" @click="moveDown(index)"/>
                    <Button icon="pi pi-trash" class="p-button-secondary p-button-link" @click="delDescription(index)"/>
                </div>
            </div>
            <div class="description-link" @click="addDescription">
                + Thêm dòng mô tả
            </div>
        </div>
      </div>
    </form>
  </template>
  
  <script>

  export default {
    name: "packageDescriptions",
    props: {
      value: Array
    },
    created() {
        if (this.descriptions.length > 0) {
            this.sortDescription();
        }
    },
    data() {
      return {
        descriptions: this.$props.value ?? []
      };
    },
    methods: {
        moveDown(index) {
            if (index != (this.descriptions.length - 1)) {
                var ordinal = this.descriptions[index].ordinal;
                this.descriptions[index].ordinal = this.descriptions[index + 1].ordinal;
                this.descriptions[index + 1].ordinal = ordinal;
                this.sortDescription();
            }
        },
        moveUp(index) {
            if (index != 0) {
                var ordinal = this.descriptions[index].ordinal;
                this.descriptions[index].ordinal = this.descriptions[index - 1].ordinal;
                this.descriptions[index - 1].ordinal = ordinal;
                this.sortDescription();
            }
        },
        sortDescription() {
            if (this.descriptions.length > 0) {
                var description = this.descriptions.sort((p1, p2) => p2.ordinal - p1.ordinal);
                var description_tmp = description.map((m, i) => {
                    var ordinal = (this.descriptions.length - i);
                    m.ordinal = ordinal;
                    return m;
                });
                this.descriptions = description_tmp;
                this.$emit("input", this.descriptions);
            }
        },
        addDescription() {
            var ordinal = 1;
            if (this.descriptions.length > 0) {
                ordinal = this.descriptions[(this.descriptions.length - 1)].ordinal - 1 ; 
            }
            this.descriptions.push({
                description: "",
                ordinal: ordinal
            })
            this.sortDescription();
        },
        delDescription(index) {
            this.descriptions.splice(index, 1);
            this.sortDescription();
        }
    }
  };
  </script>
  
<style lang="scss">
    .description-gr-icon {
        display: flex;
        button span{
            color: #000;
        }
    }
    .description-link {
        color: #0086C4;
        cursor: pointer;
        font-style: italic;
    }
    button[disabled="disabled"] span {
        cursor: no-drop;
    }
</style>
  